import { getContractTypeName } from '@/app/common/converters/contractTypeToTextConverter'
import { getSettlementTypeName } from '@/app/common/converters/settlementTypeToTextConverter'
import { getWorkTimeName } from '@/app/common/converters/workTimeToTextConverter'
import { ContractType } from '@/app/constants/contractType'
import { getContractType } from '@/app/services/contract/contractTypeResolver'
import { getSettlementType } from '@/app/services/contract/settlementTypeResolver'
import { SettlementType } from '@/app/constants/settlementType'
import TableRadio from '@/modules/drivers/shared/tableItems/TableRadio'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { FaIcon, faTrash } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

// WPF DriverContractToContractAmountConverter
const getRateText = (contract, t) => {
  const type = getContractType(contract?.type)
  const settlement = getSettlementType(contract?.settlement)
  const isCivilLawOrSelfEmployment =
    type === ContractType.CivilLawAgreement ||
    type === ContractType.SelfEmployment
  const showsMinimalRate =
    contract?.isMinimalContractRate === true &&
    (isCivilLawOrSelfEmployment
      ? settlement === SettlementType.Hour
      : settlement === SettlementType.Month ||
        settlement === SettlementType.ForContract)

  if (showsMinimalRate) return t('rate.minimal')
  return Number(contract?.contractRate ?? 0)
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0')
}

const TemplateRowItem = ({ selectedIds, template, toggleId, onDelete }) => {
  const isAnyChecked = selectedIds.length > 0
  const { t } = useLocalize()

  const isChecked = selectedIds.includes(Number(template?.templateId))

  const [isHovered, setIsHovered] = React.useState(false)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  return (
    <tr
      className={`notches-border--right tw-group tw-relative tw-cursor-pointer tw-border-b hover:tw-bg-primary/10 ${isChecked ? 'selected tw-bg-primary/10' : 'tw-bg-white'}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => toggleId(Number(template?.templateId), !isChecked)}
    >
      <TableRadio
        isHovered={isHovered}
        background
        disabled={isAnyChecked && !isChecked}
        checked={isChecked}
        onClick={() => toggleId(Number(template?.templateId), !isChecked)}
      />
      <TableTextRow size="small" >
        {template?.templateName}
      </TableTextRow>
      <TableTextRow size="small" >
        {getContractTypeName(getContractType(template?.contract?.type), t)}
      </TableTextRow>
      <TableTextRow size="small" >
        {getWorkTimeName(template?.contract?.workTime, t)}
      </TableTextRow>
      <TableTextRow size="small" >
        {getSettlementTypeName(
          getSettlementType(template?.contract?.settlement),
          t,
        )}
      </TableTextRow>
      <TableTextRow size="small" >
        {getRateText(template?.contract, t)}
      </TableTextRow>
      <td className="tw-w-10 tw-px-3 tw-py-2.5">
        <button
          type="button"
          title={t('operation.delete')}
          className="tw-invisible tw-flex tw-items-center tw-rounded tw-p-1 tw-text-content-base/60 hover:tw-bg-error/10 hover:tw-text-error group-hover:tw-visible"
          onClick={(e) => {
            e.stopPropagation()
            onDelete(template)
          }}
        >
          <FaIcon icon={faTrash} className="tw-h-4 tw-w-4" />
        </button>
      </td>
    </tr>
  )
}

export default TemplateRowItem
